export default {"en-US": __webpack_public_path__ + "i18n/en-US.0d4c5e88.i18next.json"};